import React from 'react';
import './TextInput.css';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const TextInput: React.FC<TextInputProps> = ({ value, onChange, placeholder }) => {
  const maxLength = 500;
  const characterCount = value.length;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (text && text.length <= maxLength) {
        onChange(text);
      } else if (text.length > maxLength) {
        // Truncate text if it's longer than max length
        onChange(text.substring(0, maxLength));
      }
    } catch (error) {
      console.error('Failed to read clipboard contents:', error);
      // Fallback: focus on textarea so user can paste manually
      const textarea = document.querySelector('.text-input') as HTMLTextAreaElement;
      if (textarea) {
        textarea.focus();
      }
    }
  };

  return (
    <div className="text-input-container">
      <div className="input-header">
        <span className="input-label">Seu Texto</span>
      </div>
      
      <div className="textarea-container">
        <textarea
          className="text-input"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        
        {!value && (
          <div className="paste-button-container">
            <button className="paste-button" onClick={handlePaste}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Colar Texto
            </button>
          </div>
        )}
      </div>
      
      <div className="input-footer">
        <span className="character-count">
          {characterCount} / {maxLength} caracteres
        </span>
      </div>
    </div>
  );
};

export default TextInput;